// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2qL-s","large":"styles_large__3MbTW"};